export default "__VITE_ASSET__BulMAU20__"